var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.08949548192102863"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H67.667V67.667H135.333V135.333H203V203H0V0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H67.667V67.667H135.333V135.333H203V203H0V0Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.477832512315271, 1.477832512315271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H67.667V67.667H135.333V135.333H203V203H0V0Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.08949548192102863)",
    transform: "scale(1.477832512315271, 1.477832512315271)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg54);
export default __webpack_public_path__ + "static/media/54.da82dc979c896ee133ed0aa0a598f48d.svg";
export { ForwardRef as ReactComponent };